import { render, staticRenderFns } from "./ApprovedList.vue?vue&type=template&id=6312c6bc&scoped=true"
import script from "./ApprovedList.vue?vue&type=script&lang=js"
export * from "./ApprovedList.vue?vue&type=script&lang=js"
import style0 from "./ApprovedList.vue?vue&type=style&index=0&id=6312c6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6312c6bc",
  null
  
)

export default component.exports